/**
 * Cross-module "Report Issue" button.
 *
 * Drop this anywhere in School / Church / Studio / Events / Housing admin views
 * to let any authenticated user file a maintenance ticket into the unified
 * Facilities backend (/api/facilities/maintenance).
 *
 * Auto-prefills scope_type / scope_id / scope_label from props.
 */
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Wrench } from 'lucide-react';
import { TicketDialog } from '@/pages/FacilitiesModule';

export default function ReportIssueButton({ scopeType, scopeId, scopeLabel, variant = 'outline', size = 'sm', className = '', label = 'Report issue' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant={variant}
        size={size}
        className={`text-amber-700 border-amber-300 hover:bg-amber-50 ${className}`}
        onClick={() => setOpen(true)}
        data-testid={`report-issue-${scopeType}`}
      >
        <Wrench className="h-3.5 w-3.5 mr-1" />{label}
      </Button>
      {open && (
        <TicketDialog
          defaultScope={{ type: scopeType, id: scopeId, label: scopeLabel }}
          onClose={() => setOpen(false)}
          onSaved={() => setOpen(false)}
        />
      )}
    </>
  );
}
